import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import "../styles/Asummery.css";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";

function ViewSummery() {
  const [pivotData, setPivotData] = useState([]);
  const [emails, setEmails] = useState([]);
  const [reviewList, setReviewList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [emailStatus, setEmailStatus] = useState("");
  const navigate = useNavigate();

  // ✅ Initialize EmailJS (run once on component mount)
  useEffect(() => {
    emailjs.init("poMjLpgbDWMlrTmI8");
    console.log("📧 EmailJS initialized");
  }, []);

  // ✅ NEW: Check if user has any views in the reviews
  function hasAnyViews(userEmail, reviews) {
    return reviews.some(r => {
      const reviewEmail = (r.userEmail || "").trim().toLowerCase();
      const targetEmail = userEmail.trim().toLowerCase();
      return reviewEmail === targetEmail;
    });
  }

  // ✅ Send email to admins if non-compliant (only for users with views)
  async function sendEmailAlert(nonCompliant, weekRangeText, activeEmails) {
    const ADMIN_EMAILS = [   
      // "adishav@yahoo.com",
      "sarachandrahotels@gmail.com",
    //   "rm.lake@centauriahotels.com",
      // "centaurialakehotel@gmail.com",
      
    ];

    console.log("📧 sendEmailAlert called");
    console.log("Non-compliant entries:", nonCompliant.length);

    // 🔹 Filter to only include users with views
    const activeNonCompliant = nonCompliant.filter(item => 
      activeEmails.includes(item.email)
    );

    if (activeNonCompliant.length === 0) {
      console.log("✅ All users with views are compliant this week!");
      setEmailStatus("✅ All users are compliant!");
      return;
    }

    // 🔹 Group by user email and summarize
    const grouped = activeNonCompliant.reduce((acc, item) => {
      if (!acc[item.email]) {
        acc[item.email] = {
          points: [],
          totalIssues: 0
        };
      }
      acc[item.email].points.push(`${item.point} (${item.count})`);
      acc[item.email].totalIssues++;
      return acc;
    }, {});

    // 🔹 Build COMPACT HTML content (under 50KB limit)
    const userCount = Object.keys(grouped).length;
    const totalIssues = activeNonCompliant.length;
    
    // Limit to first 20 users if too many
    const userEntries = Object.entries(grouped).slice(0, 20);
    const hasMore = Object.keys(grouped).length > 20;
    
    const messageHtml = userEntries
      .map(([email, data]) => {
        // Limit to first 10 points per user
        const points = data.points.slice(0, 10);
        const morePoints = data.points.length > 10;
        
        const pointsList = points
          .map(p => `• ${p}`)
          .join("<br>");
        
        return `
          <div style="margin-bottom: 12px; padding: 8px; background: #fff; border-left: 3px solid #d9534f;">
            <strong>${email}</strong> (${data.totalIssues} points)<br>
            <div style="font-size: 13px; margin-top: 4px;">${pointsList}</div>
            ${morePoints ? `<div style="font-size: 12px; color: #666;">...and ${data.points.length - 10} more</div>` : ''}
          </div>
        `;
      })
      .join("");

    const subject = `⚠️ Weekly Compliance Report (${weekRangeText}) – sarathchandra textile`;

    console.log("📤 Sending emails to:", ADMIN_EMAILS);
    console.log("Subject:", subject);
    console.log("Total users with issues:", userCount);
    console.log("Total non-compliant points:", totalIssues);
    setEmailStatus("📤 Sending emails...");

    try {
      const emailPromises = ADMIN_EMAILS.map(async (to) => {
        console.log(`Sending email to: ${to}...`);
        
        const result = await emailjs.send(
          "service_ykkzu2w", // EmailJS service ID
          "template_4fd9dfk", // Template ID
          {
            to_email: to,
            hotel_name: "Sarathchandra Textile",
            week_range: weekRangeText,
            message_html: `
              <div style="background: #f8f9fa; padding: 12px; border-radius: 4px; margin-bottom: 12px;">
                <strong>Summary:</strong> ${userCount} user(s) with ${totalIssues} non-compliant point(s)
                ${hasMore ? '<br><em style="color: #666;">(Showing first 20 users)</em>' : ''}
              </div>
              ${messageHtml}
            `,
            subject_line: subject,
          },
          "poMjLpgbDWMlrTmI8" // Public key
        );
        
        console.log(`✅ Email sent to ${to}:`, result.status, result.text);
        return result;
      });

      await Promise.all(emailPromises);
      console.log("📨 All emails sent successfully!");
      setEmailStatus(`✅ Emails sent! (${userCount} users, ${totalIssues} issues)`);
      
      // Show success alert with black text
      alert(`Weekly compliance report sent successfully!\n${userCount} users with ${totalIssues} non-compliant points.`);
      
    } catch (error) {
      console.error("❌ EmailJS Error:", error);
      console.error("Error details:", error.text || error.message);
      
      // If still too large, send summary only
      if (error.text && error.text.includes("Variables size limit")) {
        console.log("⚠️ Email too large, sending summary only...");
        await sendSummaryEmail(ADMIN_EMAILS, userCount, totalIssues, weekRangeText, grouped);
      } else {
        setEmailStatus("❌ Failed to send emails. Check console.");
        alert(`Failed to send emails: ${error.text || error.message}`);
      }
    }
  }

  // 🔹 Fallback: Send summary-only email if data is too large
  async function sendSummaryEmail(adminEmails, userCount, totalIssues, weekRangeText, grouped) {
    try {
      // Create super compact summary
      const topUsers = Object.entries(grouped)
        .sort((a, b) => b[1].totalIssues - a[1].totalIssues)
        .slice(0, 10)
        .map(([email, data]) => `${email}: ${data.totalIssues} issues`)
        .join("<br>");

      const summaryHtml = `
        <div style="background: #fff3cd; padding: 12px; border-radius: 4px; margin-bottom: 12px;">
          ⚠️ <strong>Note:</strong> Full report too large. Showing summary only.
        </div>
        <div style="background: #f8f9fa; padding: 12px; border-radius: 4px;">
          <strong>Total:</strong> ${userCount} user(s) | ${totalIssues} non-compliant point(s)<br><br>
          <strong>Top 10 users by issues:</strong><br>
          ${topUsers}
        </div>
        <p style="margin-top: 16px; color: #666; font-size: 14px;">
          Please check the admin dashboard for full details.
        </p>
      `;

      await Promise.all(
        adminEmails.map(to =>
          emailjs.send(
            "service_ykkzu2w",
            "template_4fd9dfk",
            {
              to_email: to,
              hotel_name: "Sarathchandra Textile",
              week_range: weekRangeText,
              message_html: summaryHtml,
              subject_line: `⚠️ Weekly Compliance Summary (${weekRangeText}) – Sarathchandra Textile`,
            },
            "poMjLpgbDWMlrTmI8"
          )
        )
      );

      console.log("📨 Summary email sent successfully!");
      setEmailStatus(`✅ Summary sent! (${userCount} users, ${totalIssues} issues)`);
      alert(`Summary email sent!\n${userCount} users with ${totalIssues} issues.`);
    } catch (error) {
      console.error("❌ Failed to send summary email:", error);
      setEmailStatus("❌ Failed to send summary email");
      alert("Failed to send even summary email. Please check console.");
    }
  }

  // ✅ Weekly compliance check (last 7 days) - only for users with views
  async function checkWeeklyCompliance(reviewList, allowedEmails, uniquePoints, activeEmails) {
    const endOfRange = new Date();
    const startOfRange = new Date();
    startOfRange.setDate(endOfRange.getDate() - 6);
    startOfRange.setHours(0, 0, 0, 0);
    endOfRange.setHours(23, 59, 59, 999);

    const weekRangeText = `${startOfRange.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
    })} – ${endOfRange.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    })}`;

    console.log("📅 Checking compliance for last 7 days:", weekRangeText);
    console.log("👥 Checking only users with views:", activeEmails);

    const nonCompliant = [];

    // 🔹 Only check users who have at least one view
    for (const email of activeEmails) {
      for (const point of uniquePoints) {
        const userReviews = reviewList.filter((r) => {
          if (!r.createdAt?.toDate) return false;
          const visitDate = new Date(r.createdAt.toDate());
          return (
            (r.userEmail || "Unknown") === email &&
            (r.qrData || "Unknown Point") === point &&
            visitDate >= startOfRange &&
            visitDate <= endOfRange
          );
        });

        if (userReviews.length < 7) {
          nonCompliant.push({
            email,
            point,
            count: userReviews.length,
          });
        }
      }
    }

    console.log("Non-compliant count:", nonCompliant.length);

    if (nonCompliant.length > 0) {
      await sendEmailAlert(nonCompliant, weekRangeText, activeEmails);
    } else {
      console.log("✅ All users with views are compliant in the last 7 days!");
      setEmailStatus("✅ All users compliant - No email needed");
    }
  }

  // ✅ Fetch data from Firestore
  useEffect(() => {
    async function fetchData() {
      try {
        console.log("🔄 Fetching data...");
        
        // 🔹 Fetch users
        const usersSnap = await getDocs(collection(db, "users"));
        const usersData = usersSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const allowedUsers = usersData.filter((u) => u.role !== "security");
        const allowedEmails = allowedUsers.map((u) => u.email);

        console.log("👥 All allowed emails:", allowedEmails);

        // 🔹 Fetch reviews
        let reviews = (await getDocs(collection(db, "reviews"))).docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((r) => r.hotelName === "Sarathchandra Textile");

        console.log("📋 Total reviews fetched:", reviews.length);

        // 🔹 Filter by date range (UI filter)
        if (startDate) {
          const start = new Date(startDate);
          const beforeFilter = reviews.length;
          reviews = reviews.filter(
            (r) => r.createdAt && r.createdAt.toDate() >= start
          );
          console.log(`📅 Start date filter: ${beforeFilter} -> ${reviews.length} reviews`);
        }
        if (endDate) {
          const end = new Date(endDate);
          end.setHours(23, 59, 59, 999);
          const beforeFilter = reviews.length;
          reviews = reviews.filter((r) => r.createdAt?.toDate() <= end);
          console.log(`📅 End date filter: ${beforeFilter} -> ${reviews.length} reviews`);
        }

        setReviewList(reviews);

        // 🔹 NEW: Filter to only users who have at least one view
        const activeEmails = allowedEmails.filter(email => 
          hasAnyViews(email, reviews)
        );

        console.log("👥 Users with views:", activeEmails.length);
        console.log("🚫 Users without views (hidden):", allowedEmails.length - activeEmails.length);

        // 🔹 Unique points (excluding SP)
        const uniquePoints = [
          ...new Set(
            reviews
              .map((r) => r.qrData || "Unknown Point")
              .filter((point) => !point.toLowerCase().startsWith("s p"))
          ),
        ];

        console.log("📍 Unique points:", uniquePoints);

        // 🔹 Build pivot table - only for users with views
        const table = uniquePoints.map((point) => {
          const row = { point };
          
          // 🔹 Only include users who have at least one view
          activeEmails.forEach((email) => {
            const userReviews = reviews.filter(
              (r) =>
                (r.userEmail || "Unknown") === email &&
                (r.qrData || "Unknown Point") === point
            );
            const count = userReviews.length;

            let lastDate = "-";
            if (userReviews.length > 0) {
              const latestReview = userReviews.reduce((latest, current) => {
                const latestTime =
                  latest.createdAt?.toDate?.()?.getTime?.() || 0;
                const currentTime =
                  current.createdAt?.toDate?.()?.getTime?.() || 0;
                return currentTime > latestTime ? current : latest;
              });
              lastDate = latestReview.createdAt?.toDate
                ? latestReview.createdAt
                    .toDate()
                    .toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "short",
                    })
                : "-";
            }

            row[email] =
              count > 0 ? (
                <>
                  {count}
                  <br />
                  ({lastDate})
                </>
              ) : (
                "-"
              );
          });
          return row;
        });

        // 🔹 FINAL FILTER: Remove users who have NO views for ANY point in the table
        const usersWithActualViews = activeEmails.filter(email => {
          return table.some(row => {
            const cellValue = row[email];
            // Check if this user has any non-dash value in this row
            return cellValue !== "-" && cellValue !== undefined;
          });
        });

        console.log("👥 Users with actual views in table:", usersWithActualViews.length);
        console.log("🚫 Users filtered out (no views in current date range):", activeEmails.length - usersWithActualViews.length);

        // Rebuild table with only users who have actual views
        const filteredTable = table.map((row) => {
          const newRow = { point: row.point };
          usersWithActualViews.forEach(email => {
            newRow[email] = row[email];
          });
          return newRow;
        });

        setEmails(usersWithActualViews); // Only show users with actual views in table
        setPivotData(filteredTable);

        // 🕒 Weekly email check with localStorage to prevent duplicate sends
        const today = new Date();
        const lastEmailDate = localStorage.getItem("lastWeeklyEmailDate");
        const todayStr = today.toDateString();

        console.log("📅 Today:", today.toLocaleDateString(), "| Day:", today.getDay());
        console.log("📧 Last email sent:", lastEmailDate || "Never");

        // Send email if it's Sunday (0) AND we haven't sent one today
        if (today.getDay() === 0 && lastEmailDate !== todayStr) {
          console.log("🟢 It's Sunday! Running compliance check...");
          await checkWeeklyCompliance(reviews, allowedEmails, uniquePoints, activeEmails);
          localStorage.setItem("lastWeeklyEmailDate", todayStr);
        } else {
          console.log("⏸️ Not Sunday or email already sent today");
        }
        
        console.log("✅ Data processing complete");
      } catch (error) {
        console.error("Error fetching data:", error);
        setEmailStatus("❌ Error loading data");
      }
    }

    fetchData();
  }, [startDate, endDate]);

  return (
    <div className="summary-container">
      <h2 style={{ color: "black" }}>📊 User Points Summary</h2>

      {/* Email Status Display */}
      {emailStatus && (
        <div
          style={{
            padding: "10px",
            marginBottom: "10px",
            backgroundColor: emailStatus.includes("❌") ? "#fee" : "#efe",
            border: `1px solid ${emailStatus.includes("❌") ? "#fcc" : "#cfc"}`,
            borderRadius: "4px",
            fontSize: "14px",
            color: "#000", // Black text color
            fontWeight: "500",
          }}
        >
          {emailStatus}
        </div>
      )}

      {/* Test Email Button */}
      <button
        onClick={() => {
          console.log("🧪 Manual test triggered");
          if (reviewList.length === 0 || emails.length === 0 || pivotData.length === 0) {
            alert("Please wait for data to load first!");
            return;
          }
          checkWeeklyCompliance(
            reviewList,
            emails, // All allowed emails
            pivotData.map((row) => row.point),
            emails // Active emails (users with views)
          );
        }}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          marginRight: "10px",
          marginBottom: "10px",
        }}
      >
        🧪 Send Email
      </button>

      <button onClick={() => navigate("/securitysum")} className="history-btn">
        Security Points Summery 
      </button>

      <div className="date-filter">
        <label>
          Start Date:
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label>
          End Date:
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
      </div>

      {emails.length === 0 ? (
        <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
          No users with views to display
        </div>
      ) : (
        <div className="table">
          <table className="summary-table">
            <thead>
              <tr>
                <th>Points</th>
                {emails.map((email, idx) => (
                  <th key={idx}>{email.split("@")[0]}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pivotData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>{row.point}</td>
                  {emails.map((email, idx) => (
                    <td key={idx}>{row[email]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ViewSummery;